export const MZUSD_ABI = [
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': '_usdc',
        'type': 'address'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'constructor'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'authority',
        'type': 'address'
      }
    ],
    'name': 'AccessManagedInvalidAuthority',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'caller',
        'type': 'address'
      },
      {
        'internalType': 'uint32',
        'name': 'delay',
        'type': 'uint32'
      }
    ],
    'name': 'AccessManagedRequiredDelay',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'caller',
        'type': 'address'
      }
    ],
    'name': 'AccessManagedUnauthorized',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'account',
        'type': 'address'
      }
    ],
    'name': 'AccountNotAllowed',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'target',
        'type': 'address'
      }
    ],
    'name': 'AddressEmptyCode',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'enum PauseCategory',
        'name': 'category',
        'type': 'uint8'
      }
    ],
    'name': 'CategoryPaused',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'implementation',
        'type': 'address'
      }
    ],
    'name': 'ERC1967InvalidImplementation',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'ERC1967NonPayable',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'spender',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'allowance',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'needed',
        'type': 'uint256'
      }
    ],
    'name': 'ERC20InsufficientAllowance',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'sender',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'balance',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'needed',
        'type': 'uint256'
      }
    ],
    'name': 'ERC20InsufficientBalance',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'approver',
        'type': 'address'
      }
    ],
    'name': 'ERC20InvalidApprover',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'receiver',
        'type': 'address'
      }
    ],
    'name': 'ERC20InvalidReceiver',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'sender',
        'type': 'address'
      }
    ],
    'name': 'ERC20InvalidSender',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'spender',
        'type': 'address'
      }
    ],
    'name': 'ERC20InvalidSpender',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'FailedCall',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'capUSDC',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'newTotal',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'attemptedUSDC',
        'type': 'uint256'
      }
    ],
    'name': 'GlobalRedemptionCapExceeded',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'InvalidInitialization',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'InvalidRedemptionWindowDuration',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'uint8',
        'name': 'actualDecimals',
        'type': 'uint8'
      }
    ],
    'name': 'InvalidUSDCDecimals',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'NotInitializing',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'NotVault',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'PauseManagerZeroAddress',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'SameValue',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'TooBigBps',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'requestedMZ',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'usdcOut',
        'type': 'uint256'
      }
    ],
    'name': 'TooSmallWithdrawalAmount',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'UUPSUnauthorizedCallContext',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'bytes32',
        'name': 'slot',
        'type': 'bytes32'
      }
    ],
    'name': 'UUPSUnsupportedProxiableUUID',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'VaultAlreadySet',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'VaultNotSet',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'ZeroAddress',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'ZeroAmount',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'ZeroCap',
    'type': 'error'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'allowlist',
        'type': 'address'
      }
    ],
    'name': 'AllowlistUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      },
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'spender',
        'type': 'address'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'value',
        'type': 'uint256'
      }
    ],
    'name': 'Approval',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'address',
        'name': 'authority',
        'type': 'address'
      }
    ],
    'name': 'AuthorityUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'user',
        'type': 'address'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'usdcAmount',
        'type': 'uint256'
      }
    ],
    'name': 'Deposit',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'newCapUSDC',
        'type': 'uint256'
      }
    ],
    'name': 'GlobalRedemptionCapQueued',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'newCapUSDC',
        'type': 'uint256'
      }
    ],
    'name': 'GlobalRedemptionCapUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'uint64',
        'name': 'version',
        'type': 'uint64'
      }
    ],
    'name': 'Initialized',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'newManager',
        'type': 'address'
      }
    ],
    'name': 'PauseManagerUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'uint32',
        'name': 'newDuration',
        'type': 'uint32'
      }
    ],
    'name': 'RedemptionWindowDurationQueued',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'uint32',
        'name': 'newDuration',
        'type': 'uint32'
      }
    ],
    'name': 'RedemptionWindowDurationUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'from',
        'type': 'address'
      },
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'to',
        'type': 'address'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'value',
        'type': 'uint256'
      }
    ],
    'name': 'Transfer',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'implementation',
        'type': 'address'
      }
    ],
    'name': 'Upgraded',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'vault',
        'type': 'address'
      }
    ],
    'name': 'VaultUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'user',
        'type': 'address'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'usdcOut',
        'type': 'uint256'
      }
    ],
    'name': 'Withdrawal',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'newFeeBps',
        'type': 'uint256'
      }
    ],
    'name': 'WithdrawalFeeUpdated',
    'type': 'event'
  },
  {
    'inputs': [],
    'name': 'BPS',
    'outputs': [
      {
        'internalType': 'uint16',
        'name': '',
        'type': 'uint16'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'MAX_REDEMPTION_WINDOW_DURATION',
    'outputs': [
      {
        'internalType': 'uint32',
        'name': '',
        'type': 'uint32'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'MAX_WITHDRAWAL_FEE_BPS',
    'outputs': [
      {
        'internalType': 'uint16',
        'name': '',
        'type': 'uint16'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'MIN_REDEMPTION_WINDOW_DURATION',
    'outputs': [
      {
        'internalType': 'uint32',
        'name': '',
        'type': 'uint32'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'MZ_DECIMALS',
    'outputs': [
      {
        'internalType': 'uint8',
        'name': '',
        'type': 'uint8'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'UPGRADE_INTERFACE_VERSION',
    'outputs': [
      {
        'internalType': 'string',
        'name': '',
        'type': 'string'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'USDC_DECIMALS',
    'outputs': [
      {
        'internalType': 'uint8',
        'name': '',
        'type': 'uint8'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      },
      {
        'internalType': 'address',
        'name': 'spender',
        'type': 'address'
      }
    ],
    'name': 'allowance',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'allowlist',
    'outputs': [
      {
        'internalType': 'contract IAllowlist',
        'name': '',
        'type': 'address'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'spender',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'value',
        'type': 'uint256'
      }
    ],
    'name': 'approve',
    'outputs': [
      {
        'internalType': 'bool',
        'name': 'success',
        'type': 'bool'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'authority',
    'outputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'account',
        'type': 'address'
      }
    ],
    'name': 'balanceOf',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'amount',
        'type': 'uint256'
      }
    ],
    'name': 'burn',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'decimals',
    'outputs': [
      {
        'internalType': 'uint8',
        'name': '',
        'type': 'uint8'
      }
    ],
    'stateMutability': 'pure',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'amountUSDC',
        'type': 'uint256'
      }
    ],
    'name': 'deposit',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'getRedemptionWindow',
    'outputs': [
      {
        'internalType': 'uint48',
        'name': 'windowStart',
        'type': 'uint48'
      },
      {
        'internalType': 'uint48',
        'name': 'windowEnd',
        'type': 'uint48'
      },
      {
        'internalType': 'uint32',
        'name': 'duration',
        'type': 'uint32'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'getRemainingRedemptionCap',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': 'capUSDC',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'usedUSDC',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'remainingUSDC',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'globalRedemptionCapUSDC',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'accessManager',
        'type': 'address'
      },
      {
        'internalType': 'address',
        'name': 'pauseManager_',
        'type': 'address'
      },
      {
        'internalType': 'address',
        'name': 'allowlist_',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': '_initialCapUSDC',
        'type': 'uint256'
      }
    ],
    'name': 'initialize',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'isConsumingScheduledOp',
    'outputs': [
      {
        'internalType': 'bytes4',
        'name': '',
        'type': 'bytes4'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'to',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'amount',
        'type': 'uint256'
      }
    ],
    'name': 'mint',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'name',
    'outputs': [
      {
        'internalType': 'string',
        'name': '',
        'type': 'string'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'nextGlobalRedemptionCapUSDC',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'nextRedemptionWindowDuration',
    'outputs': [
      {
        'internalType': 'uint32',
        'name': '',
        'type': 'uint32'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'pauseManager',
    'outputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'proxiableUUID',
    'outputs': [
      {
        'internalType': 'bytes32',
        'name': '',
        'type': 'bytes32'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'redemptionWindowDuration',
    'outputs': [
      {
        'internalType': 'uint32',
        'name': '',
        'type': 'uint32'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'amountMZ',
        'type': 'uint256'
      }
    ],
    'name': 'requestWithdrawal',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': '_allowlist',
        'type': 'address'
      }
    ],
    'name': 'setAllowlist',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'newAuthority',
        'type': 'address'
      }
    ],
    'name': 'setAuthority',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'newCapUSDC',
        'type': 'uint256'
      }
    ],
    'name': 'setGlobalRedemptionCap',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint32',
        'name': 'newDuration',
        'type': 'uint32'
      }
    ],
    'name': 'setRedemptionWindowDuration',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': '_vault',
        'type': 'address'
      }
    ],
    'name': 'setVault',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint16',
        'name': 'newFeeBps',
        'type': 'uint16'
      }
    ],
    'name': 'setWithdrawalFeeBps',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'symbol',
    'outputs': [
      {
        'internalType': 'string',
        'name': '',
        'type': 'string'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'totalSupply',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'to',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'value',
        'type': 'uint256'
      }
    ],
    'name': 'transfer',
    'outputs': [
      {
        'internalType': 'bool',
        'name': 'success',
        'type': 'bool'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'from',
        'type': 'address'
      },
      {
        'internalType': 'address',
        'name': 'to',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'value',
        'type': 'uint256'
      }
    ],
    'name': 'transferFrom',
    'outputs': [
      {
        'internalType': 'bool',
        'name': 'success',
        'type': 'bool'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'newImplementation',
        'type': 'address'
      },
      {
        'internalType': 'bytes',
        'name': 'data',
        'type': 'bytes'
      }
    ],
    'name': 'upgradeToAndCall',
    'outputs': [],
    'stateMutability': 'payable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'usdc',
    'outputs': [
      {
        'internalType': 'contract IERC20',
        'name': '',
        'type': 'address'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'vault',
    'outputs': [
      {
        'internalType': 'contract IVault',
        'name': '',
        'type': 'address'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'windowStartTimestamp',
    'outputs': [
      {
        'internalType': 'uint48',
        'name': '',
        'type': 'uint48'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'windowUsedUSDC',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'withdrawalFeeBps',
    'outputs': [
      {
        'internalType': 'uint16',
        'name': '',
        'type': 'uint16'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  }
] as const;
